/* eslint-disable @typescript-eslint/no-explicit-any */

export type ChannelType =
  | 'APP'
  | 'WEB'
  | 'WEB_FLOW'
  | 'UNIVERSAL_LOGIN'
  | 'Novos planos Lancamento';

export type BugsnagEnvs = 'development' | 'production' | 'staging';

const APIEnvDEV = [
  'MOCK',
  'DEV1',
  'DEV2',
  'DEV3',
  'DEV4',
  'DEV5',
  'DEV6',
  'DEV7',
  'DEV8',
  'DEV9',
  'DEV10',
  'DEV1-N',
  'DEV2-N',
  'DEV3-N',
  'DEV4-N',
  'DEV5-N',
  'DEV6-N',
  'DEV7-N',
  'DEV8-N',
  'DEV9-N',
  'DEV10-N',
] as const;

const APIEnvHML = [
  'HML1',
  'HML2',
  'HML3',
  'HML4',
  'HML5',
  'HML6',
  'HML7',
  'HML8',
  'HML9',
  'HML10',
  'HML1-N',
  'HML2-N',
  'HML3-N',
  'HML4-N',
  'HML5-N',
  'HML6-N',
  'HML7-N',
  'HML8-N',
  'HML9-N',
  'HML10-N',
] as const;

const APIEnvPRD = ['PRD'] as const;

export const DefaultAPIEnvs = {
  development: APIEnvDEV,
  homologation: APIEnvHML,
  production: APIEnvPRD,
};
export type DefaultEnvs = keyof typeof DefaultAPIEnvs;

export type APIEnvs =
  | typeof APIEnvDEV[number]
  | typeof APIEnvHML[number]
  | typeof APIEnvPRD[number];

export type EndPointsNames =
  | 'ApiMain'
  | 'ApiGoogle'
  | 'ApiLiferay'
  | 'ApiAuth0'
  | 'ApiLaunchdarkly'
  | 'ApiLaunchdarklyRelay'
  | 'ApiLaunchdarklyRelayNew'
  | 'ApiLaunchdarklyRelayBLUE'
  | 'ApiLaunchdarklyRelayGREEN'
  | 'ApiUpload'
  | 'ApiFileEnvironment'
  | 'ApiGwBr'
  | 'ApiGwBrOther'
  | 'ApiGwAr'
  | 'ApiGwArOther'
  | 'ApiOAG';

export type ApiEndPointsNames = EndPointsNames | string;

export type ApiCredentialsType =
  | 'NOT_CREDENTIALS'
  | 'TOKEN_CREDENTIALS'
  | 'TOKEN_AUTH_USER'
  | 'TOKEN_AUTH_USER_OR_CREDENTIALS'
  | 'TOKEN_X_API_KEY';

export type InitApiType = {
  params?: any;
  body?: any;
  headers?: any;
  pathParameters?: any;
  proxy?: {
    host: string;
    port: number;
  };
  pathUrl?: string | null;
  withCredentials?: boolean;
};

export const ApiOrigin = [
  'Smiles',
  'Smiles-Liferay',
  'Smiles-Auth0',
  'Google',
  'Smiles-Launchdarkly',
  'Smiles-other',
  'Smiles-FileEnvironment',
  'Smiles-OAG',
] as const;

export type ApiOriginType = typeof ApiOrigin[number];

export type RegionType = 'Brasil' | 'VOEBIZ';

export type ServiceTypes = {
  environment: APIEnvs;
  logger: boolean;
  timeout: number;
  region: RegionType;
  mockTimeout?: number;
};

export type UserType = {
  memberNumber: number;
  password: string;
};

export type ConfigItemStatus = {
  name: string;
  success: boolean;
  errorMessage: string;
  environmentLD?: string;
};

export type AppOS = 'iOS' | 'Android';
